import React, { useMemo } from 'react';
import * as S from './card-header-classic.style';
import { useTranslation } from 'react-i18next';
import { Checkout } from '../../../../../common/types/checkout';
import { formatCurrency } from '../../../../../common/utils/format-currency';
import { BillingPeriodUnit } from '../../../../../common/types/enums/billing-period-unit';

type Props = {
  checkout: Checkout;
};

export const CardHeaderClassic: React.FC<Props> = ({ checkout }) => {
  const { t } = useTranslation();
  const getRecurrentLabel = useMemo(() => {
    switch (checkout?.plano?.billingConfig?.billingPeriodUnit) {
      case BillingPeriodUnit.Month:
        return t('perMonth');
      case BillingPeriodUnit.Week:
        return t('perWeek');
      case BillingPeriodUnit.Year:
        return t('perYear');
      case BillingPeriodUnit.Day:
        return t('perDay');
      default:
        return t('cashPayment');
    }
  }, [checkout?.plano?.billingConfig?.billingPeriodUnit, t]);
  return (
    <S.CardHeader>
      <div>
        <h2>
          {checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader
            ?.text ?? checkout?.produto?.nome}
        </h2>
        <S.Price
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader
              ?.subtitleColor
          }
        >
          {formatCurrency(checkout?.total, checkout?.moeda)}
          {checkout?.recorrencia ? getRecurrentLabel : ` ${t('cashPayment')}`}
        </S.Price>
      </div>
    </S.CardHeader>
  );
};
